import { ReactElement } from 'react';
import '@assets/styles/pages/login-page.scss';
import { Navigate, useLocation } from 'react-router-dom';
import { useRouteHandler } from '../authGuard';

import { useRefetchAllData } from '@helper/fetchData';

export const SSoLoginPage = (): ReactElement => {
	const { isAuthenticated } = useRouteHandler();
	const { refetchAllData } = useRefetchAllData();

	const { pathname: path } = useLocation();
	if (path === '/sso-login/' && isAuthenticated()) {
		const oldPermissions = localStorage.getItem('permissions');

		if (oldPermissions) {
			localStorage.removeItem('permissions');
		}
		refetchAllData?.();
	}
	return <Navigate to="/" replace />;
};
